import { useState } from 'react'
import { AddPill, Body, Box, Button, Dialog, H4, Icon, UserPill } from '../'
import { Form, Submit, Text } from '../../forms'
import { userRoles } from '../../../lookups'
import './TeamLeaderDialog.scss'

export const TeamLeaderDialog = ({ users, newLeaders, leaders, onSelected, onClose, ...props }) => {
  const [selectedUser, setSelectedUser] = useState()
  const [inviteNewLead, setInviteNewLead] = useState(false)

  const availableUsers = users.filter(user => !leaders.includes(user.id))

  const handleLeader = (email) =>  {
    if(inviteNewLead && email) {
      onSelected(email, true)
    } else if (selectedUser) {
      onSelected(selectedUser)
    }
    close()
  }

  const close = () => {
    onClose()
    setInviteNewLead(false)
    setSelectedUser()
  }

  return (
    <Dialog {...props} onClose={close} mobileBackground="white">
      <Box fullWidth p="0 32px" justifyContent="center">
        <H4 color="black">{inviteNewLead ? 'Invite new team leader' : 'Team Leaders'}</H4>
      </Box>
      <Body color="black" align="center">{userRoles.teamLeader.description}</Body>
      {inviteNewLead
        ? <InviteNewLeader
            users={users}
            newLeaders={newLeaders}
            leaders={leaders}
            onNewLeaderSubmitted={handleLeader}
            onBackClicked={() => setInviteNewLead(false)}
          />
        : <>
            {availableUsers.length > 0 && (
              <Box className="black-scroller" fullWidth gap={8} maxHeight={250} p="4px 4px" overflowX="visible" overflowY="auto" column>
                {availableUsers.map((user, index) => (
                  <UserPill
                    key={index}
                    user={user}
                    invited
                    action={!user?.onboard}
                    blackListBackgrounds={['white']}
                    onClick={() => setSelectedUser(user.id)}
                    selected={selectedUser === user.id}
                  />
                ))}
              </Box>
            )}
            <Box p="2px 2px" fullWidth>
              <AddPill text="Add new" onClick={() => setInviteNewLead(true)} removeSpacing/>
            </Box>
            <Box height={1} background="black" fullWidth/>
            <Button fullWidth onClick={handleLeader}>Save</Button>
          </>
        }
    </Dialog>
  )
}

const InviteNewLeader = ({ users, newLeaders, leaders, onNewLeaderSubmitted, onBackClicked }) => {
  const [message, setMessage] = useState('')

  const submit = ({ email }) => {
    const userIndex = users.findIndex(user => user.email === email)

    if(userIndex > -1) {
      setMessage('This user already exists in this organisation.')
    } else if(newLeaders.includes(email) || leaders.includes(email)) {
      setMessage('This user has already been added to this team.')
    } else {
      setMessage('')
      onNewLeaderSubmitted(email)
    }
  }

  return (
    <Form onSubmit={submit} style={{ width: "100%" }}>
      <Box className="invite-leader-container">
        <Text
          dark
          title="Send email invite"
          type="email"
          name="email"
          id="new-email"
          description={message}
          error={message}
          required
        />
        <Box className="leaders-back-button" onClick={onBackClicked}>
          <Icon icon="LeftArrow" fill="black"/>
        </Box>
        <Box height={1} background="black" fullWidth/>
        <Submit fullWidth>Save</Submit>
      </Box>
    </Form>
  )
}